export default function GetSessionData() {
  return {
    CompanyId: Number(sessionStorage.getItem('Companyid')) || 0,
    CompanyBranchId: Number(sessionStorage.getItem('CompanyBranchId')) || 0,
    CompanyStateCode: Number(sessionStorage.getItem('CompanyStateCode')) || 0,
    CustomerId: Number(sessionStorage.getItem('Customer_Log')) || 0,
    CustomerBranchId: Number(sessionStorage.getItem('CustomerBranchId')) || 0,
    CustomerHOId: Number(sessionStorage.getItem('CustomerHo_id')) || 0,
    BranchId: Number(sessionStorage.getItem('Branch_Log')) || 0,
    BranchName: sessionStorage.getItem('BranchName'),
    StateId: Number(sessionStorage.getItem('StateId')) || 0,
    StateCode: Number(sessionStorage.getItem('StateCode')) || 0,
    UserId: Number(sessionStorage.getItem('Userid')) || 0,
    Indent_User :sessionStorage.getItem('IndentUser') || 'N',
    Indent_Approval_User :sessionStorage.getItem('IndentApprovalUser') || 'N',
    PO_User : sessionStorage.getItem('POUser') || 'N',
    PO_Approval_User: sessionStorage.getItem('POApprovalUser') || 'N',
    AllBranch: sessionStorage.getItem('AllBranch') || 'N',
    Indent_Required:sessionStorage.getItem('Indent_Required') || 'N',
    PO_Approval_Required:sessionStorage.getItem('PO_Approval_Required') || 'N',
    Indent_Approval_Required:sessionStorage.getItem('Indent_Approval_Required') || 'N',
    IndentApproval_POApproval_Required:sessionStorage.getItem('IndentApproval_POApproval_Required') || 'N',
    UserName: sessionStorage.getItem('Username') || '',
    CustomerName:sessionStorage.getItem('CustomerName') || '',
    CustomerHOName:sessionStorage.getItem('CustomerHo_Name') || '',
    tokent:sessionStorage.getItem('authtoken')
  };
}
